/*
 * @Author: RYL
 * @Description: ep
 * @Date: 2020-10-26 15:34:45
 * @LastEditTime: 2022-03-22 14:07:29
 */
import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";
export function getTemplate(data) {
  return http({
    url: '/api2/template/list',
    method: 'post',
    data,
  })
}
// 条件搜索模板
export function queryTempalte(data) {
  return http({
    // url: '/api2/template/query',
    url: '/api2/template/list',
    method: 'post',
    data
  })
}
// 添加模板
export function addTemplate(params) {
  const mydata = {
    uid: getuser_id(),
    type:params.type,
    name: params.name,
    admodel: params.admodel,
    description: params.description?params.description:""
  }
  return http({
    url: '/api2/template/add',
    method: 'post',
    data: mydata
  })
}

// 修改
export function editTemplate(data) {
  return http({
    url: '/api2/template/edit',
    method: 'post',
    data,
  })
}
 
// 删除
export function deleteTemplate(id) {
  return http({
    url: '/api2/template/del',
    method: 'post',
    data: {
      id,
    }
  })
}

